import TaxiCorporationListRequest, {
  TaxiCorporationListRequestOrder,
} from "../../../api/raily/taxi-corporation/list/taxi-corporation-list.request";
import paginationService from "../../../utils/pagination/pagination.service";
import TaxiCorporationListParams, {
  TaxiCorporationListParamsOrder,
} from "./taxi-corporation-list-params";

const createOrder = (
  status: TaxiCorporationListParamsOrder | undefined,
): TaxiCorporationListRequestOrder | undefined => {
  switch (status) {
    case TaxiCorporationListParamsOrder.COMPANY_NAME_ASC:
      return TaxiCorporationListRequestOrder.COMPANY_NAME_ASC;
    case TaxiCorporationListParamsOrder.COMPANY_NAME_DESC:
      return TaxiCorporationListRequestOrder.COMPANY_NAME_DESC;
    case TaxiCorporationListParamsOrder.DISPLAY_NAME_ASC:
      return TaxiCorporationListRequestOrder.DISPLAY_NAME_ASC;
    case TaxiCorporationListParamsOrder.DISPLAY_NAME_DESC:
      return TaxiCorporationListRequestOrder.DISPLAY_NAME_DESC;

    default:
      return undefined;
  }
};

const create = (
  params: TaxiCorporationListParams,
): TaxiCorporationListRequest => {
  return {
    headquartersAddressString: params.address,
    companyName: params.name,
    displayName: params.displayName,
    krsNo: params.nationalCourtRegister,
    notes: params.notes,
    regon: params.companyId,
    taxId: params.taxNumber,
    creationStart: params.creationDateFrom,
    creationEnd: params.creationDateTo,
    limit: params.pageSize,
    offset:
      params.page && params.pageSize
        ? paginationService.calculateOffset(params.page, params.pageSize)
        : undefined,
    order: createOrder(params.order),
  };
};

const taxiCorporationListParamsFactory = { create };

export default taxiCorporationListParamsFactory;
